// The header of a part of a prospection list (« Terminés », « À appeler », a
// day of « Mes sessions »): white, its title and its count, held on top while
// its part scrolls under it (the next one taking its place). As a button
// (`onClick`, `expanded`) it folds its part, `children` holding its chevron.
export const SECTION_HEADER_CLASS =
  'sticky top-0 z-10 flex h-12 w-full items-center justify-between border-b border-line bg-white font-title text-sm font-medium text-ink';

// `aside`: beside the title, in the plain header only (a button holds no other).
const SectionHeader = ({ title, count, onClick, expanded, aside = null, children }) => {
  const label = (
    <span>
      {title} <span className="text-muted">· {count}</span>
    </span>
  );
  return onClick ? (
    <button type="button" aria-expanded={expanded} onClick={onClick} className={SECTION_HEADER_CLASS}>
      {label}
      {children}
    </button>
  ) : (
    <div className={SECTION_HEADER_CLASS}>
      {aside ? (
        <span className="flex items-center gap-3">
          {label}
          {aside}
        </span>
      ) : (
        label
      )}
      {children}
    </div>
  );
};

export default SectionHeader;
